"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deprecationWarning = exports.deprecationWarning = function deprecationWarning(message) {
  return console.warn("RMWC Deprecation Warning: " + message);
};